/* 개발망 */

import type { SettingConfigSiteInfo } from './type';

// bktv
export const developmentBktv: SettingConfigSiteInfo = {
  PC_URL: 'https://www.bktv.kr',
  BASE_URL: 'https://www.bktv.kr',
  API_URL: 'api.bktv.kr',
  CACHE_API_URL: 'cache-api.bktv.kr',
  EVENT_URL: 'https://events.bktv.kr',
  STATS_URL: 'https://stats.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
export const mDevelopmentBktv: SettingConfigSiteInfo = {
  PC_URL: 'https://www.bktv.kr',
  BASE_URL: 'https://m.bktv.kr',
  API_URL: 'api.bktv.kr',
  CACHE_API_URL: 'cache-api.bktv.kr',
  EVENT_URL: 'https://events.bktv.kr',
  STATS_URL: 'https://stats.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.bktv.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// 상망 api에 연결된 개발망
export const productionDevWwwPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://dev-www.pandalive.co.kr',
  BASE_URL: 'https://dev-www.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  CACHE_API_URL: 'cache-api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  // 개발망 배포(상망 api 조합) 트래픽이 상망 stats DB를 오염시키지 않도록 개발망 수집 서버 사용
  STATS_URL: 'https://stats.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
export const mProductionDevWwwPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://dev-www.pandalive.co.kr',
  BASE_URL: 'https://dev-m.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  CACHE_API_URL: 'cache-api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  STATS_URL: 'https://stats.bktv.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// Fanza
export const developmentFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://dev.pandalive.co.jp',
  BASE_URL: 'http://dev.pandalive.co.jp',
  API_URL: 'dev-gapi.pandalive.co.jp',
  CACHE_API_URL: 'dev-cache-gapi.pandalive.co.jp',
  EVENT_URL: 'https://events.pandatv.dmm.co.jp',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://dev-chat-ws.pandalive.co.jp/connection/websocket',
};

export const mDevelopmentFanza: SettingConfigSiteInfo = {
  PC_URL: 'http://dev.pandalive.co.jp',
  BASE_URL: 'http://dev-m.pandalive.co.jp',
  API_URL: 'dev-gapi.pandalive.co.jp',
  CACHE_API_URL: 'dev-cache-gapi.pandalive.co.jp',
  EVENT_URL: 'https://events.pandatv.dmm.co.jp',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://dev-chat-ws.pandalive.co.jp/connection/websocket',
};
